export const selectedInvoiceIdKey = 'selectedInvoiceId';
export const selectedContractIdKey = 'selectedContractId';
export const editingContractIdKey = 'editingContractId';

/**
 * Which tab the contract edit dialog opens on. Absent (or anything else) means General.
 * The dialog is mounted app-wide by `ContractEditDialogFlow`, so the URL is the only
 * way a page can ask it for a particular section.
 */
export const editingContractSectionKey = 'editingContractSection';
export const CONTRACT_FORM_REVIEW_RULES_TAB = 'review-rules';
export const selectedCarIdKey = 'selectedCarId';
export const selectedTabSearchParam = 'tab';

/** Which elevator a property's Elevators tab has expanded. */
export const carSearchParam = 'carId';

/**
 * The old compliance panel's tab key. Nothing in the app writes it any more — the
 * elevator page names its tabs in `tab` — so it is read-only now, for legacy bookmarks
 * arriving through `selectedCarId`. Absent (or anything else) means the Compliance tab.
 */
export const carPanelTabKey = 'carPanelTab';
export const CAR_PANEL_HISTORY_TAB = 'history';
export const currencyCodeMap = {
  GBP: '£',
  USD: '$',
} as const;
